// Variables

// Variables: Layout

window.breakpoint = {
  xs:     480,
  sm:     768,
  md:     992,
  md_sh: 1120,
  lg:    1200,
  lg_sh: 1346,
  xl:    1920,
};
